<template>
  <component :is="as" :class="classes" v-on="listeners">
    <component v-if="!isSeparator"
               :is="triggerTag"
               v-bind="triggerAttrs"
               v-on="triggerListeners"
    >
      <svg-icon v-if="!!item.icon" class="menu-item__icon" :class="item.iconClass" :icon="item.icon"
                width="16" height="16"></svg-icon>
      <div v-else-if="!!item.iconClass" class="menu-item__icon" :class="item.iconClass"></div>

      <span class="menu-item__text">{{ item.title }}</span>
      <svg-icon v-if="!!item.specialIcon" class="menu-item__spec-icon" :class="item.specialIconClass"
                :icon="item.specialIcon" width="16" height="16"></svg-icon>
      <svg-icon v-if="item.items.length > 0" icon="lh-menu-arrow-right" class="menu-item__arrow" width="12"
                height="12"></svg-icon>
    </component>
  </component>

</template>

<script>
import SvgIcon from "@/common/controls/SvgIconControl.vue";
import {MenuItemType} from "../types";

export default {
  components: {
    SvgIcon,
  },
  props: {
    as: {
      type: String,
      default: "li",
    },
    item: Object,
  },
  data() {
    return {};
  },
  computed: {
    isSeparator() {
      return this.item.type === MenuItemType.Separator;
    },

    classes() {
      if (this.isSeparator) {
        return {
          "dropdown-divider": true,
        };
      }

      return {
        "dropdown-item-2": true,
      };
    },

    listeners() {
      const hasChildren = (this.item.items || []).length > 0;
      return {
        mouseover: (e) => {
          this.$emit("mouseover", e);
        },
        click: (e) => {
          if (hasChildren && !this.isSeparator) {
            this.$emit("click", this.item);
          }
        },
      };
    },

    triggerTag() {
      const hasChildren = (this.item.items || []).length > 0;

      if (hasChildren) {
        return "span";
      } else {
        return "a";
      }
    },
    triggerAttrs() {
      const hasChildren = (this.item.items || []).length > 0;
      if (hasChildren) {
        return {
          class: "menu-item__layout",
          "aria-expanded": "false",
        };
      }
      return {
        href: this.item.targetUrl,
        target: this.item.isLocalUrl ? "_self" : "_blank",
      };
    },

    triggerListeners() {
      const children = this.item.items || [];
      if (children.length === 0 && !this.isSeparator) {
        return {
          click: () => this.$emit("click", this.item),
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>

.dropdown-item-2 {
  padding: 2px 4px;
  border-radius: var(--border-radius-sm);
  
  a {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    color: inherit;
    
    svg {
      color: var(--main-10);
    }
  }
  
  &:hover {
    background-color: var(--main-10);
    color: var(--white);
    
    svg {
      color: inherit;
    }
    
    .menu-item__arrow {
      color: inherit;
    }
  }
}

.dropdown-divider {
  margin: 10px 0 5px 0;
  border-block-start: 2px solid var(--main-40);
}

.menu-item__layout {
  display: flex;
  gap: 8px;
  flex-flow: row nowrap;
  align-items: center;
}

.menu-item__icon {
  + .menu-item__text {
    margin-inline-start: 8px;
  }
}

.menu-item__spec-icon {
  margin-inline-start: 8px;
}

.menu-item__arrow {
  margin-inline-start: auto;
  color: var(--main-10);

  [dir="rtl"] & {
    transform: rotate(180deg);
  }
}

</style>
